<div id="container-carousel" class="container-carousel px-6 mx-auto max-w-[1240px] my-10">
  <div class="relative overflow-hidden rounded-[14px]">
    <!-- Carrusel -->
    <div #carousel id="carousel" class="flex transition-transform duration-500 ease-in-out w-full">
      <!-- Slide 1 -->
      <div class="hero-carousel-slide min-w-full flex flex-col justify-center items-center p-4 text-white rounded-[14px]">
        <div class="hero-carousel-content text-center">
          <p class="text-sm text-gray-300">Griky</p>
          <h2 class="text-lg font-semibold text-gray-200">Giving positive and constructive feedback</h2>
          <p class="text-sm text-gray-400 description-2 mt-2">
            To train for: Giving positive feedback, to motivate the other person and improve their self-confidence...
          </p>
          <div class="flex items-center mt-2 text-gray-400">
            <i class="fa fa-clock text-sm"></i>
            <span class="ml-2 text-sm">12h 20min</span>
          </div>
          <button class="hero-button mt-4 flex items-center justify-center">
            <span>Iniciar Curso</span>
            <i class="fas fa-angle-double-right ml-2"></i>
          </button>
        </div>
      </div>

      <!-- Slide 2 -->
      <div class="hero-carousel-slide min-w-full flex flex-col justify-center items-center p-4 text-white rounded-[14px]">
        <div class="hero-carousel-content text-center">
          <p class="text-sm text-gray-300">Griky</p>
          <h2 class="text-lg font-semibold text-gray-200">Giving positive and constructive feedback</h2>
          <p class="text-sm text-gray-400 description-2 mt-2">
            To train for: Giving positive feedback, to motivate the other person and improve their self-confidence...
          </p>
          <div class="flex items-center mt-2 text-gray-400">
            <i class="fa fa-clock text-sm"></i>
            <span class="ml-2 text-sm">12h 20min</span>
          </div>
          <button class="hero-button mt-4 flex items-center justify-center">
            <span>Iniciar Curso</span>
            <i class="fas fa-angle-double-right ml-2"></i>
          </button>
        </div>
      </div>

      <!-- Slide 3 -->
      <div class="hero-carousel-slide min-w-full flex flex-col justify-center items-center p-4 text-white rounded-[14px]">
        <div class="hero-carousel-content text-center">
          <p class="text-sm text-gray-300">Griky</p>
          <h2 class="text-lg font-semibold text-gray-200">Giving positive and constructive feedback</h2>
          <p class="text-sm text-gray-400 description-2 mt-2">
            To train for: Giving positive feedback, to motivate the other person and improve their self-confidence...
          </p>
          <div class="flex items-center mt-2 text-gray-400">
            <i class="fa fa-clock text-sm"></i>
            <span class="ml-2 text-sm">12h 20min</span>
          </div>
          <button class="hero-button mt-4 flex items-center justify-center">
            <span>Iniciar Curso</span>
            <i class="fas fa-angle-double-right ml-2"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Flechas -->
    <button #prevBtn id="prev" (click)="prevSlide()"
      class="absolute top-1/2 left-2 transform -translate-y-1/2 text-gray-400 p-1 rounded-full bg-gray-800 bg-opacity-50 hover:bg-opacity-75 transition">
      <i class="fa-solid fa-chevron-left w-5 h-5 flex justify-center items-center"></i>
    </button>
    <button #nextBtn id="next" (click)="nextSlide()"
      class="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-400 p-1 rounded-full bg-gray-800 bg-opacity-50 hover:bg-opacity-75 transition">
      <i class="fa-solid fa-chevron-right w-5 h-5 flex justify-center items-center"></i>
    </button>

    <!-- Bullets -->
    <div #bullets class="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
      <span class="cursor-pointer bullet w-2 h-2 bg-gray-400 rounded-full"></span>
      <span class="cursor-pointer bullet w-2 h-2 bg-gray-400 rounded-full"></span>
      <span class="cursor-pointer bullet w-2 h-2 bg-gray-400 rounded-full"></span>
    </div>
  </div>
</div>